'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';


let settings = {
    fieldSelector: '.js-ajax-form__field',
    fieldNamePrefix: '.js-ajax-form__field--',
    contentSelector: '.js-ajax-form__content',
    captchaSelector: '#recaptchaResponse',
    errorClass: 'is-error'
};


class Form {
    constructor(el, options) {
        this.el = el;
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ Form ] init', this.el);

        this.$form = $(this.el);
        this.$fields = this.opt.$fields || $(this.opt.fieldSelector, this.el);
        this.$content = this.opt.$content || $(this.opt.contentSelector).filter('[data-form_id="' + this.$form.data('form_id') + '"]');
        this.$captcha = $(this.opt.captchaSelector, this.el);

        this._initFields();
        this._initEvents();

        if ($.fancybox.isOpen) {
            $.fancybox.update();
        }
    }
    submit() {
        console.log('[ Form ] submit', this.el);

        if (!this.isLoading) {
            this._beforeSubmit();
            this._processSubmit();
        }
    }
    _initFields() {
		let self = this;
        this.$fields.filter(this.opt.fieldNamePrefix + 'captcha').remove();

      	this.$fields.filter(this.opt.fieldNamePrefix + 'city_review').find(' .input').on('keyup', function() {
	        if ($(this).val().length > 1) {
	          $.ajax({
	            method: "POST",
	            url: "/cities/",
	            data: { term: $(this).val()}
	          }).then((data) => {
	            $(this).siblings('.js-city-input__result').html('');
	            $(this).siblings('.js-city-input__result').css('display','block');
	            for (var i = 0; i < 50 && i<data.length; i++) {
	              $('.js-city-input__result').append('<div data-city_id="'+data[i].value+'" class="js-city-item selectmark__term--item m--no-after">'+data[i].label+'</span></div>');
	            }
	            $('.js-city-input__result .js-city-item').on('click', function() {
					console.warn($(this).text(), $(this).data());
					self.$fields.filter(self.opt.fieldNamePrefix + 'city_review').find(' .input').val($(this).text());
					self.$fields.filter(self.opt.fieldNamePrefix + 'city_review').find('[name=city_id]').val($(this).data('city_id'));
	            })
	          })
	        }
      	})

      	$(document).mouseup(function (e){
			var div = $(".js-city-input__result");
			if (!div.is(e.target)) {
				$('.js-city-input__result').css('display','none');
			}
      	})
    }
    _initEvents() {
        this.$form.on('submit', (e) => {
            e.preventDefault();
            this.submit();
        });
    }
    _beforeSubmit() {
        this.isLoading = true;

        this.$fields.removeClass(this.opt.errorClass);

        var instance = $.fancybox.getInstance();
        if (instance) instance.showLoading();
		console.warn('show Loader');
		this.$form.find('[type=submit]').prop('disabled', true);
    }
    _processSubmit() {
        if (this.$captcha) {
            this._recaptcha(this.$captcha);
        }   

        let params = new FormData(this.el);

        Ajax.get('send_form', params).then((data) => {
            if (data.ok) {
                console.log('[ Form/_processSubmit ] Sent successfully');

                if (this.$form.data('goal')) {
                    $(window).trigger('goal.main', this.$form.data());
                }

                if (this.$content.length) {
                    this.$content.html(data.content);
                    this.$form.remove();
                } else {
                    this.$form.replaceWith(data.content);
                }
                this._afterSubmit();
            } else if (data.errors) {
                console.log('[ Form/_processSubmit ] Got errors', data.errors);

                for (let p in data.errors) {
                    this.$fields.filter(this.opt.fieldNamePrefix + p).addClass(this.opt.errorClass);
                }
                this._afterSubmit();
            }
        }).catch(function(error) {
            console.error('[ Form/_processSubmit ] Sending failed', error);

            this._afterSubmit();
        });
    }
    _afterSubmit() {
     	var instance = $.fancybox.getInstance();
      	if (instance) instance.hideLoading();
		console.warn('hide Loader');
		this.$form.find('[type=submit]').prop('disabled', false);
        if ($.fancybox.isOpen) {
            $.fancybox.update();
        }

        this.isLoading = false;
    }
    _recaptcha (input) {
        let SiteKey = $(input).data('site_key');

        if (SiteKey) {
            grecaptcha.ready(function () {
                grecaptcha.execute(`${SiteKey}`, { action: 'submit' }).then(function (token) {
                    $(input).val(token);
                });
            });
        }
    }
    
    
}


export {
    Form
};
